// @ts-ignore
import { StudentSubjectsQuery } from '@school_ify/schoolify-repository/src/student/types';

import { StudyTypes } from './types';

const { ADD_ACTIVE_CLASS, ADD_CLASSES } = StudyTypes;

interface HeaderState {
  classes: StudentSubjectsQuery[];
  active: StudentSubjectsQuery;
}

export const initialState: HeaderState = {
  classes: null,
  active: null,
};

// eslint-disable-next-line default-param-last
const headerReducer = (state = initialState, action: any): HeaderState => {
  switch (action.type) {
    case ADD_CLASSES: {
      return {
        ...state,
        classes: action.payload,
      };
    }
    case ADD_ACTIVE_CLASS: {
      return {
        ...state,
        active: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default headerReducer;
